export default __webpack_public_path__ + "static/media/default_news.14c3a053.jpg";